<template>
  <div class="timeInlineList">
    <nuxt-link class="item" v-for="item in list" :key="item.id" :to="`${toPath}${item.id}?from=${Route.path}`">
      <div class="time" v-if="item.createTime">
        <div class="date">{{ dayjs(item.createTime).format("MM-DD") }}</div>
        <div class="year">{{ dayjs(item.createTime).format("YYYY") }}</div>
      </div>
      <div class="title">{{item.contentTitle}}</div>
      <div class="moreBtn">查看更多</div>
    </nuxt-link>
  </div>
</template>

<script setup>
import dayjs from "dayjs";

const Route = useRoute();

const props = defineProps({
  list: {
    required: true,
    type: Array
  },
  toPath: {
    required: true,
    type: String
  }
})
</script>

<style scoped lang="scss">
.timeInlineList {
  margin-top: 62px;
  > .item {
    margin-bottom: 24px;
    width: 100%;
    height: 84px;
    background: rgba(166, 208, 233, 0.1);
    cursor: pointer;
    display: flex;
    align-items: center;
    text-decoration: none;
    //justify-content: space-between;
    > .time {
      width: 123px;
      height: 100%;
      border: 2px solid var(--main-blue-color);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      line-height: 1;
      > .date {
        color: var(--main-blue-color);
        font-size: 20px;
        padding-bottom: 15px;
      }
      > .year {
        color: #4D9DFD;
        font-size: 17px;
        border-top: 1px solid #4D9DFD;
        padding-top: 10px;
      }
    }
    > .title {
      font-size: 18px;
      color: var(--title-text-color);
      padding-left: 57px;
    }
    > .moreBtn {
      margin-left: auto;
      padding: 0 23px;
      line-height: 40px;
      border-radius: 25px;
      box-sizing: border-box;
      border: 1px solid var(--main-blue-color);
      font-size: 14px;
      color: var(--main-blue-color);
      cursor: pointer;
      margin-right: 33px;
    }
    &:hover {
      transition: all ease-in-out .3s;
      background: var(--white);
      box-shadow: 8px 4px 38px 1px rgba(0, 10, 39, 0.1);
      > .time {
        background-color: var(--main-blue-color);
        transition: all ease-in-out .3s;
        > .date {
          color: var(--white);
        }
        > .year {
          color: var(--white);
          border-color: var(--white);
        }
      }
      > .moreBtn {
        transition: all ease-in-out .3s;
        background-color: var(--main-blue-color);
        color: var(--white);
      }
    }
  }
}
</style>